import request from '@/services/request'
import { getApiUrl } from '@/utils/tool'

export function login(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/login',
    method: 'post',
    data: object
  })
}

export function getPhoneCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-phone-code',
    method: 'post',
    data: object
  })
}

export function verifyPhoneCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/verify-phone-code',
    method: 'post',
    data: object
  })
}

export function getEmailCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-email-code',
    method: 'post',
    data: object
  })
}

export function verifyEmailCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/verify-email-code',
    method: 'post',
    data: object
  })
}

export function resetPassword(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/reset-password',
    method: 'post',
    data: object
  })
}

export function forgetPassword(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/forget-password',
    method: 'post',
    data: object
  })
}

export function register(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/register-and-login',
    method: 'post',
    data: object
  })
}

export function gold() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/gold',
    method: 'post'
  })
}
// 所有member pool的內容
export function goldInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/gold-info',
    method: 'post'
  })
}

export function info() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/me',
    method: 'post'
  })
}

export function update(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/update',
    method: 'post',
    data: object
  })
}

export function getAgentInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-agent-info',
    method: 'post'
  })
}

export function addParent(promotion_code) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/add-parent',
    method: 'post',
    data: {
      promotion_code: promotion_code
    }
  })
}

export function getTransferInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-transfer-info',
    method: 'post'
  })
}

export function setTransferInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/set-transfer-info',
    method: 'post',
    data: object
  })
}

export function requestAgent() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/request-agent',
    method: 'post'
  })
}

export function letter() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/letter',
    method: 'post'
  })
}

export function getPersonalSummary(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-personal-summary',
    method: 'post',
    data: object
  })
}

export function getPersonalAnalysis() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-personal-analysis',
    method: 'post'
  })
}

export function getPromotionAnalysis() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-promotion-analysis',
    method: 'post'
  })
}

export function getLetter(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-letter',
    method: 'post',
    data: object
  })
}

export function setLetterRead(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/set-letter-read',
    method: 'post',
    data: object
  })
}

export function setAllLetterRead(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/set-all-letter-read',
    method: 'post',
    data: object
  })
}

export function getPromotionInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-promotion-info',
    method: 'post'
  })
}

export function applyAgent(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/apply-agent',
    method: 'post',
    data: object
  })
}

export function shareBetOnChat(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/share-bet-info-on-chat',
    method: 'post',
    data: object
  })
}
export function autoToGame(status) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/auto-to-game',
    method: 'post',
    data: {
      status: status
    }
  })
}
